/* Pensum — Live-Konfigurator
   Steuert Vorschau, Aufdruck, Schriftwahl, Druckfarbe, Farbfelder sowie das
   Verschieben auf dem Cardholder. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- Farben */

  function parseHex(hex) {
    var value = String(hex || '').trim().replace('#', '');
    if (value.length === 3) {
      value = value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
    }
    var number = parseInt(value, 16);
    if (value.length !== 6 || isNaN(number)) return null;
    return { r: (number >> 16) & 255, g: (number >> 8) & 255, b: number & 255 };
  }

  function toHex(rgb) {
    function part(value) {
      var clamped = Math.max(0, Math.min(255, Math.round(value)));
      return (clamped < 16 ? '0' : '') + clamped.toString(16);
    }
    return '#' + part(rgb.r) + part(rgb.g) + part(rgb.b);
  }

  function mix(hex, targetHex, amount) {
    var a = parseHex(hex);
    var b = parseHex(targetHex);
    if (!a || !b) return hex;
    return toHex({
      r: a.r + (b.r - a.r) * amount,
      g: a.g + (b.g - a.g) * amount,
      b: a.b + (b.b - a.b) * amount
    });
  }

  function luminance(hex) {
    var rgb = parseHex(hex);
    if (!rgb) return 1;
    return (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  }

  // Relative Helligkeit nach WCAG — anders als luminance() oben wird hier
  // korrekt entzerrt, weil daraus Kontrastwerte gerechnet werden.
  function relLuminance(hex) {
    var rgb = parseHex(hex);
    if (!rgb) return 1;
    function kanal(value) {
      var c = value / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * kanal(rgb.r) + 0.7152 * kanal(rgb.g) + 0.0722 * kanal(rgb.b);
  }

  function contrast(hexA, hexB) {
    var a = relLuminance(hexA);
    var b = relLuminance(hexB);
    var hell = Math.max(a, b);
    var dunkel = Math.min(a, b);
    return (hell + 0.05) / (dunkel + 0.05);
  }

  var WHITE = '#FFFFFF';
  var BLACK = '#000000';

  // Kräftiger machen: den Abstand jedes Kanals zum Grauwert vergrößern.
  // Bei Grautönen wie Silber ändert das nichts, das ist beabsichtigt.
  function saturate(hex, amount) {
    var rgb = parseHex(hex);
    if (!rgb) return hex;
    var grau = (rgb.r + rgb.g + rgb.b) / 3;
    return toHex({
      r: grau + (rgb.r - grau) * amount,
      g: grau + (rgb.g - grau) * amount,
      b: grau + (rgb.b - grau) * amount
    });
  }

  // Der Aufdruck muss auf jedem Untergrund klar stehen. Deshalb wird die
  // Druckfarbe für die Anzeige verstärkt, bis sie sich deutlich abhebt.
  var LESBAR = 5.0;
  var STUFEN = 16;
  var MITTE = 0.18;

  function fitInk(inkHex, grundHex) {
    var kraeftig = saturate(inkHex, 1.25);
    if (contrast(kraeftig, grundHex) >= LESBAR) return kraeftig;

    // Jede Druckfarbe wird nur in ihre eigene Richtung verstärkt: eine helle
    // wird heller, eine dunkle dunkler. Sie springt nie über die Mitte —
    // sonst erschiene „Weiß" auf hellem Leder als Grau und „Schwarz" auf
    // dunklem als Grau, und der Kunde sähe etwas anderes, als er gewählt hat.
    var istHell = relLuminance(kraeftig) > MITTE;

    // Liegen Farbe und Untergrund auf derselben Seite, kann diese Farbe hier
    // nicht gewinnen. Sie bleibt, wie sie ist; der Konfigurator schlägt von
    // sich aus eine andere vor.
    if (istHell === (relLuminance(grundHex) > MITTE)) return kraeftig;

    var ziel = istHell ? WHITE : BLACK;
    for (var i = 1; i <= STUFEN; i++) {
      var kandidat = mix(kraeftig, ziel, i / STUFEN * 0.85);
      if (contrast(kandidat, grundHex) >= LESBAR) return kandidat;
    }
    return mix(kraeftig, ziel, 0.85);
  }

  function tonesFor(base) {
    var isDark = luminance(base) < 0.42;
    return {
      isDark: isDark,
      base: base,
      light: mix(base, WHITE, isDark ? 0.34 : 0.2),
      mid: mix(base, WHITE, isDark ? 0.18 : 0.1),
      dark: mix(base, BLACK, 0.32),
      deep: mix(base, BLACK, isDark ? 0.42 : 0.5),
      // Ton in Ton wie auf den Produktfotos, keine Kontrastnaht.
      stitch: isDark ? mix(base, WHITE, 0.22) : mix(base, BLACK, 0.22),
      edge: mix(base, BLACK, isDark ? 0.45 : 0.55),
      highlight: isDark ? mix(base, WHITE, 0.26) : mix(base, WHITE, 0.66)
    };
  }

  /* ----------------------------------------------------------- Hilfsmittel */

  var DIACRITICS = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss', 'é': 'e', 'è': 'e' };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[äöüßéè]/g, function (match) { return DIACRITICS[match] || match; })
      .replace(/\s+/g, ' ');
  }

  /* -------------------------------------------------------- Lederfarben */

  function selectSwatch(swatch) {
    var picker = swatch.closest('[data-variant-picker]');
    if (!picker) return;

    var index = swatch.getAttribute('data-swatch');
    var select = picker.querySelector('select[data-option-select="' + index + '"]');
    if (!select) return;

    var value = swatch.getAttribute('data-swatch-value');
    var siblings = picker.querySelectorAll('.swatch[data-swatch="' + index + '"]');

    Array.prototype.forEach.call(siblings, function (element) {
      var isActive = element === swatch;
      element.classList.toggle('is-selected', isActive);
      element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    var label = picker.querySelector('[data-option-value="' + index + '"]');
    if (label) label.textContent = value;

    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.swatch');
    if (!swatch || swatch.hasAttribute('data-pz-ink')) return;
    event.preventDefault();
    selectSwatch(swatch);
  });

  /* ------------------------------------------------------- Druckfarben */

  // Dieselben Farbfelder wie bei den Lederfarben, damit die Produktseite
  // nur ein Bedienmuster kennt.
  function inkSwatch(label, index, hex) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'swatch pz__ink' + (index === 0 ? ' is-selected' : '');
    button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
    button.title = label;
    button.dataset.pzInk = String(index);
    button.style.setProperty('--swatch-color', hex);

    var name = document.createElement('span');
    name.className = 'visually-hidden';
    name.textContent = label;
    button.appendChild(name);

    return button;
  }

  /* ------------------------------------------------------ Konfigurator */

  function init(root) {
    if (root.dataset.pzBound === 'true') return;

    var configElement = root.querySelector('[data-pz-config]');
    if (!configElement) return;

    var config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }
    if (!config.fonts || !config.fonts.length) return;

    root.dataset.pzBound = 'true';

    var stage = root.querySelector('[data-pz-stage]');
    var textElement = root.querySelector('[data-pz-text]');
    var textLayer = root.querySelector('[data-pz-layer="text"]');
    var symbolElement = root.querySelector('[data-pz-symbol]');
    var symbolLayer = root.querySelector('[data-pz-layer="symbol"]');
    var resetButton = root.querySelector('[data-pz-reset]');
    var input = root.querySelector('[data-pz-input]');
    var counter = root.querySelector('[data-pz-counter]');
    var fontsHost = root.querySelector('[data-pz-fonts]');
    var inkHost = root.querySelector('[data-pz-inks]');
    var inkName = root.querySelector('[data-pz-ink-name]');
    var symbolHost = root.querySelector('[data-pz-symbols]');
    var symbolName = root.querySelector('[data-pz-symbol-name]');
    var totalLine = root.querySelector('[data-pz-total]');

    var formId = root.getAttribute('data-pz-form');
    var sectionId = root.getAttribute('data-pz-section');

    var props = {
      text: root.querySelector('[data-pz-prop="text"]'),
      font: root.querySelector('[data-pz-prop="font"]'),
      family: root.querySelector('[data-pz-prop="family"]'),
      ink: root.querySelector('[data-pz-prop="ink"]'),
      inkhex: root.querySelector('[data-pz-prop="inkhex"]'),
      textlayout: root.querySelector('[data-pz-prop="textlayout"]'),
      symbol: root.querySelector('[data-pz-prop="symbol"]'),
      symbolchar: root.querySelector('[data-pz-prop="symbolchar"]'),
      symbollayout: root.querySelector('[data-pz-prop="symbollayout"]')
    };

    var resizeObserver = null;

    var colors = {};
    Object.keys(config.colors || {}).forEach(function (key) {
      colors[normalize(key)] = config.colors[key];
    });

    var inkColors = config.inkColors || [];
    var symbols = config.symbols || [];
    var symbolAnchor = config.symbolAnchor || config.textAnchor;

    var photoElement = root.querySelector('[data-pz-photo]');
    var photos = {};
    Object.keys(config.photos || {}).forEach(function (key) {
      photos[normalize(key)] = config.photos[key];
    });

    // Beide Karten laufen über normalize(), damit „Grün" und „gruen"
    // denselben Eintrag finden.
    var photoGeo = {};
    Object.keys(config.photoGeo || {}).forEach(function (key) {
      photoGeo[normalize(key)] = config.photoGeo[key];
    });

    // Karte und Druckbereich liegen auf dem Foto anders als auf der Zeichnung.
    // Alles Weitere rechnet gegen "geo", nicht mehr gegen config.
    var geo = { card: config.card, zone: config.zone };

    var state = {
      text: '',
      font: 0,
      ink: 0,
      // Sobald der Kunde selbst eine Druckfarbe wählt, hört der Konfigurator
      // auf, beim Farbwechsel eine lesbare vorzuschlagen.
      inkChosen: false,
      symbol: -1,
      base: colors[normalize(config.color)] || '#C9C2B7',
      layer: { x: config.textAnchor.x, y: config.textAnchor.y, scale: 1 },
      symbolLayer: { x: symbolAnchor.x, y: symbolAnchor.y, scale: 1 }
    };

    // Aufdruck und Zeichen verhalten sich gleich: beide sitzen als eigene
    // Ebene im Druckbereich und lassen sich getrennt verschieben.
    var layers = [
      {
        key: 'text',
        el: textLayer,
        inner: textElement,
        pos: state.layer,
        anchor: config.textAnchor,
        limit: config.maxScale,
        moved: false
      },
      {
        key: 'symbol',
        el: symbolLayer,
        inner: symbolElement,
        pos: state.symbolLayer,
        anchor: symbolAnchor,
        limit: config.maxScale,
        moved: false
      }
    ].filter(function (layer) { return layer.el && layer.inner; });

    function layerByKey(key) {
      return layers.filter(function (layer) { return layer.key === key; })[0] || null;
    }

    // Gedruckt wird immer in einer echten Farbe — ohne Auswahl die erste.
    function inkColor() {
      var chosen = inkColors[state.ink] || inkColors[0];
      return chosen ? chosen.hex : '#1A1A18';
    }

    // Schwarze Druckfarbe verschwindet auf dunklem Kunstleder, helle auf
    // hellem. Solange der Kunde nichts eigenes gewählt hat, nimmt der
    // Konfigurator die erste Farbe, die auf diesem Leder wirklich lesbar ist.
    function readableInk() {
      var beste = 0;
      var bester = state.ink;

      for (var i = 0; i < inkColors.length; i++) {
        // Gegen die angezeigte Fassung rechnen, nicht gegen den rohen Wert —
        // sonst würde eine Farbe verworfen, die nach der Anpassung passt.
        var wert = contrast(fitInk(inkColors[i].hex, state.base), state.base);
        if (wert >= LESBAR) return i;
        if (wert > beste) { beste = wert; bester = i; }
      }
      return bester;
    }

    function selectInk(index) {
      if (index === state.ink || !inkColors[index]) return;
      state.ink = index;

      if (inkHost) {
        Array.prototype.forEach.call(inkHost.querySelectorAll('[data-pz-ink]'), function (element) {
          var isActive = parseInt(element.dataset.pzInk, 10) === state.ink;
          element.classList.toggle('is-selected', isActive);
          element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }
      if (inkName) inkName.textContent = inkColors[state.ink].name;
    }

    function form() {
      return formId ? document.getElementById(formId) : null;
    }

    /* ------------------------------------------- Anordnung auf dem Leder */

    function clampPosition(layer) {
      var zone = geo.zone;
      if (!layer || !layer.el || !stage || layer.el.hidden) return;

      var stageRect = stage.getBoundingClientRect();
      if (!stageRect.width || !stageRect.height) return;

      var rect = layer.el.getBoundingClientRect();
      var halfWidth = (rect.width / stageRect.width) * 50;
      var halfHeight = (rect.height / stageRect.height) * 50;

      var minX = zone.x + halfWidth;
      var maxX = zone.x + zone.w - halfWidth;
      var minY = zone.y + halfHeight;
      var maxY = zone.y + zone.h - halfHeight;

      layer.pos.x = maxX >= minX ? Math.min(maxX, Math.max(minX, layer.pos.x)) : zone.x + zone.w / 2;
      layer.pos.y = maxY >= minY ? Math.min(maxY, Math.max(minY, layer.pos.y)) : zone.y + zone.h / 2;
    }

    function applyLayer(layer) {
      if (!layer || !layer.el) return;
      layer.el.style.setProperty('--pz-layer-x', layer.pos.x + '%');
      layer.el.style.setProperty('--pz-layer-y', layer.pos.y + '%');
      layer.el.style.setProperty('--pz-layer-scale', layer.pos.scale);
    }

    function applyAll() {
      layers.forEach(applyLayer);
    }

    // Nur was der Kunde selbst angefasst hat, zählt als verschoben.
    function isRearranged() {
      return layers.some(function (layer) {
        return !layer.el.hidden && layer.moved;
      });
    }

    function updateReset() {
      if (resetButton) resetButton.hidden = !isRearranged();
    }

    function layoutDescription(layer) {
      var card = geo.card;
      var x = Math.round(((layer.pos.x - card.x) / card.w) * 100);
      var y = Math.round(((layer.pos.y - card.y) / card.h) * 100);
      return x + ' % / ' + y + ' %';
    }

    function resetLayout() {
      layers.forEach(function (layer) {
        layer.pos.x = layer.anchor.x;
        layer.pos.y = layer.anchor.y;
        layer.pos.scale = 1;
        layer.moved = false;
      });
      applyAll();
      layout();
      placeSymbol();
      updateReset();
      syncProperties();
    }

    function layerHeight(layer) {
      var stageRect = stage.getBoundingClientRect();
      if (!stageRect.height) return 0;
      return (layer.el.getBoundingClientRect().height / stageRect.height) * 100;
    }

    // Zeichen oben, Text darunter, beides zusammen mittig im Druckbereich.
    var SYMBOL_GAP = 1.2;
    var SYMBOL_SHARE = 0.3;

    function placeSymbol() {
      var layer = layerByKey('symbol');
      var textRef = layerByKey('text');
      if (!layer || layer.el.hidden || !stage) return;

      var zone = geo.zone;
      layer.pos.x = zone.x + zone.w / 2;

      var hasText = textRef && state.text.trim() !== '';

      if (!hasText) {
        layer.pos.y = zone.y + zone.h / 2;
        clampPosition(layer);
        applyLayer(layer);
        return;
      }

      var textH = layerHeight(textRef);
      var symbolH = layerHeight(layer);

      var room = zone.h - textH - SYMBOL_GAP;
      if (symbolH > room && symbolH > 0) {
        layer.pos.scale = Math.max(config.minScale, layer.pos.scale * (room / symbolH));
        applyLayer(layer);
        symbolH = layerHeight(layer);
      }

      var total = symbolH + SYMBOL_GAP + textH;
      var top = zone.y + Math.max(0, (zone.h - total) / 2);

      layer.pos.y = top + symbolH / 2;

      if (!textRef.moved) {
        textRef.pos.y = top + symbolH + SYMBOL_GAP + textH / 2;
        clampPosition(textRef);
        applyLayer(textRef);
      }

      clampPosition(layer);
      applyLayer(layer);
    }

    function makeInteractive(layer) {
      var element = layer.el;
      if (!element) return;

      var mode = null;
      var originX = 0;
      var originY = 0;
      var pointerX = 0;
      var pointerY = 0;
      var stageRect = null;
      var keyboardTimer = null;

      element.addEventListener('pointerdown', function (event) {
        if (typeof event.button === 'number' && event.button !== 0) return;

        stageRect = stage.getBoundingClientRect();

        // Verschieben ist die einzige Handhabung. Die Größe bestimmt der
        // Konfigurator selbst, damit der Aufdruck in den Druckbereich passt.
        mode = 'move';
        pointerX = event.clientX;
        pointerY = event.clientY;
        originX = layer.pos.x;
        originY = layer.pos.y;

        element.classList.add('is-dragging', 'is-active');
        if (stage) stage.classList.add('is-arranging');

        try {
          if (element.setPointerCapture) element.setPointerCapture(event.pointerId);
        } catch (error) { /* ohne Bindung weiter */ }

        event.preventDefault();
      });

      element.addEventListener('pointermove', function (event) {
        if (!mode || !stageRect) return;

        layer.pos.x = originX + ((event.clientX - pointerX) / stageRect.width) * 100;
        layer.pos.y = originY + ((event.clientY - pointerY) / stageRect.height) * 100;
        clampPosition(layer);

        layer.moved = true;
        applyLayer(layer);
        updateReset();
        event.preventDefault();
      });

      function finish() {
        if (!mode) return;
        mode = null;
        element.classList.remove('is-dragging', 'is-active');
        if (stage) stage.classList.remove('is-arranging');
        syncProperties();
        layout();
      }

      element.addEventListener('pointerup', finish);
      element.addEventListener('pointercancel', finish);

      element.addEventListener('keydown', function (event) {
        var step = event.shiftKey ? 3 : 1;
        var handled = true;

        switch (event.key) {
          case 'ArrowLeft': layer.pos.x -= step; break;
          case 'ArrowRight': layer.pos.x += step; break;
          case 'ArrowUp': layer.pos.y -= step; break;
          case 'ArrowDown': layer.pos.y += step; break;
          default: handled = false;
        }

        if (!handled) return;
        event.preventDefault();
        layer.moved = true;
        clampPosition(layer);
        applyLayer(layer);
        updateReset();
        syncProperties();

        if (stage) {
          stage.classList.add('is-arranging');
          clearTimeout(keyboardTimer);
          keyboardTimer = setTimeout(function () {
            stage.classList.remove('is-arranging');
          }, 1200);
        }
      });
    }

    /* ------------------------------------------------ Echtes Produktfoto */

    function zoneAusKarte(card) {
      // Beim Handy-Cardholder ist oben nur der Kartenschlitz ausgenommen —
      // die ganze Fläche darunter lässt sich bedrucken. Beim klassischen
      // Modell liegt darüber noch die aufgesetzte Tasche, dort beginnt der
      // Druckbereich erst auf halber Höhe.
      var magsafe = config.shape === 'magsafe';
      var oben = magsafe ? 0.24 : 0.46;
      var hoch = magsafe ? 0.70 : 0.44;
      var seite = magsafe ? 0.09 : 0.12;

      return {
        x: card.x + card.w * seite,
        y: card.y + card.h * oben,
        w: card.w * (1 - seite * 2),
        h: card.h * hoch
      };
    }

    function applyPhoto(colorName) {
      var key = normalize(colorName);
      var url = photos[key];
      var hasPhoto = Boolean(url) && Boolean(photoElement);

      if (hasPhoto) {
        if (photoElement.getAttribute('src') !== url) photoElement.setAttribute('src', url);
        photoElement.hidden = false;

        // Ist diese Farbe eigens vermessen, gilt ihr Wert — sonst die
        // gemeinsame Vorgabe der Serie.
        var eigen = photoGeo[key];
        if (eigen) {
          geo.card = eigen;
          geo.zone = zoneAusKarte(eigen);
        } else {
          geo.card = config.photoCard || config.card;
          geo.zone = config.photoCard ? zoneAusKarte(config.photoCard) : config.zone;
        }
      } else {
        if (photoElement) photoElement.hidden = true;
        geo.card = config.card;
        geo.zone = config.zone;
      }

      root.classList.toggle('pz--foto', hasPhoto);

      var zoneBox = root.querySelector('[data-pz-zone]');
      if (zoneBox) {
        zoneBox.style.left = geo.zone.x + '%';
        zoneBox.style.top = geo.zone.y + '%';
        zoneBox.style.width = geo.zone.w + '%';
        zoneBox.style.height = geo.zone.h + '%';
      }
    }

    // Lädt das Foto nicht, fällt die Vorschau auf die Zeichnung zurück.
    if (photoElement) {
      photoElement.addEventListener('error', function () {
        photoElement.hidden = true;
        root.classList.remove('pz--foto');
        geo.card = config.card;
        geo.zone = config.zone;
        layout();
      });
    }

    /* -------------------------------------------------- Vorschau zeichnen */

    function paint() {
      var tones = tonesFor(state.base);

      root.classList.toggle('pz--dark', tones.isDark);

      root.style.setProperty('--pz-base', tones.base);
      root.style.setProperty('--pz-light', tones.light);
      root.style.setProperty('--pz-mid', tones.mid);
      root.style.setProperty('--pz-dark', tones.dark);
      root.style.setProperty('--pz-deep', tones.deep);
      root.style.setProperty('--pz-stitch', tones.stitch);
      root.style.setProperty('--pz-edge', tones.edge);
      root.style.setProperty('--pz-hl', tones.highlight);
      // Angezeigt wird die an den Untergrund angepasste Fassung; in die
      // Bestellung geht weiterhin der echte Wert aus der Farbliste.
      root.style.setProperty('--pz-ink', fitInk(inkColor(), state.base));

      Array.prototype.forEach.call(root.querySelectorAll('[data-pz-stop]'), function (element) {
        element.setAttribute('stop-color', tones[element.getAttribute('data-pz-stop')] || tones.base);
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-pz-fill]'), function (element) {
        element.setAttribute('fill', tones[element.getAttribute('data-pz-fill')] || tones.base);
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-pz-stroke]'), function (element) {
        element.setAttribute('stroke', tones[element.getAttribute('data-pz-stroke')] || tones.base);
      });
    }

    function naturalSize(layer) {
      var innerRect = layer.inner.getBoundingClientRect();
      var layerRect = layer.el.getBoundingClientRect();
      var scale = layer.pos.scale || 1;
      return {
        width: innerRect.width / scale + (layerRect.width - innerRect.width),
        height: innerRect.height / scale + (layerRect.height - innerRect.height)
      };
    }

    function layoutLayer(layer) {
      var width = stage ? stage.clientWidth : 0;
      if (!width || layer.el.hidden) return;

      var zoneWidth = width * (geo.zone.w / 100);
      var size;

      var shareHeight = symbolLayer && !symbolLayer.hidden && state.text.trim() !== '';
      var zonePercent = geo.zone.h;

      if (shareHeight) {
        zonePercent = layer.key === 'symbol'
          ? geo.zone.h * SYMBOL_SHARE
          : geo.zone.h * (1 - SYMBOL_SHARE) - SYMBOL_GAP;
      }

      var zoneHeight = width * (Math.max(1, zonePercent) / 100);

      if (layer.key === 'text') {
        var font = config.fonts[state.font];
        size = width * (config.fontSize / 100) * (font.scale || 1);
        layer.el.style.setProperty('--pz-font', font.stack);
        layer.el.style.setProperty('--pz-track', (font.track || 0) + 'em');
      } else {
        size = width * (config.fontSize / 100) * 1.5;
        if (config.symbolFont) layer.el.style.setProperty('--pz-symbol-font', config.symbolFont);
      }

      layer.el.style.setProperty('--pz-fs', size + 'px');

      var natural = naturalSize(layer);

      var fit = 1;
      if (natural.width > zoneWidth * 0.88) fit = Math.min(fit, (zoneWidth * 0.88) / natural.width);
      if (natural.height > zoneHeight * 0.88) fit = Math.min(fit, (zoneHeight * 0.88) / natural.height);

      if (fit < 1) {
        size = size * fit;
        natural.width = natural.width * fit;
        natural.height = natural.height * fit;
        layer.el.style.setProperty('--pz-fs', size + 'px');
      }

      layer.limit = Math.max(config.minScale, Math.min(
        config.maxScale,
        (zoneWidth * 0.98) / Math.max(1, natural.width),
        (zoneHeight * 0.98) / Math.max(1, natural.height)
      ));

      if (layer.pos.scale > layer.limit) layer.pos.scale = layer.limit;
      applyLayer(layer);
      clampPosition(layer);
      applyLayer(layer);
    }

    function layout() {
      layers.forEach(layoutLayer);
    }

    /* ----------------------------------------------------------- Aufpreis */

    function updateSurcharge(hasPersonalization) {
      var productForm = form();
      var active = Boolean(config.surcharge) && hasPersonalization;

      if (productForm) {
        if (active) {
          productForm.dataset.extraVariant = config.surcharge.id;
          productForm.dataset.extraNote = config.surcharge.note || '';
        } else {
          delete productForm.dataset.extraVariant;
          delete productForm.dataset.extraNote;
        }
      }

      if (totalLine) {
        totalLine.hidden = !active;
        if (active) {
          totalLine.innerHTML = '';
          totalLine.appendChild(document.createTextNode((config.strings.surchargeLabel || '') + ': '));
          var amount = document.createElement('strong');
          amount.textContent = config.surcharge.price;
          totalLine.appendChild(amount);
        }
      }
    }

    function syncProperties() {
      var value = state.text.trim();
      var font = config.fonts[state.font];
      var ink = inkColors[state.ink];
      var symbol = symbols[state.symbol];
      var textLayerRef = layerByKey('text');
      var symbolLayerRef = layerByKey('symbol');

      var anything = value !== '' || Boolean(symbol);

      if (props.text) {
        props.text.value = value;
        props.text.disabled = value === '';
      }
      if (props.font) {
        props.font.value = font.label;
        props.font.disabled = value === '';
      }
      if (props.family) {
        props.family.value = font.stack;
        props.family.disabled = value === '';
      }
      if (props.ink) {
        props.ink.value = ink ? ink.name : '';
        props.ink.disabled = !anything || !ink;
      }
      if (props.inkhex) {
        props.inkhex.value = ink ? ink.hex : '';
        props.inkhex.disabled = !anything || !ink;
      }
      if (props.textlayout && textLayerRef) {
        props.textlayout.value = layoutDescription(textLayerRef);
        props.textlayout.disabled = value === '';
      }
      if (props.symbol) {
        props.symbol.value = symbol ? symbol.name : '';
        props.symbol.disabled = !symbol;
      }
      if (props.symbolchar) {
        props.symbolchar.value = symbol ? symbol.char : '';
        props.symbolchar.disabled = !symbol;
      }
      if (props.symbollayout && symbolLayerRef) {
        props.symbollayout.value = layoutDescription(symbolLayerRef);
        props.symbollayout.disabled = !symbol;
      }

      updateSurcharge(anything);
    }

    function renderText() {
      var placeholder = config.strings.empty || '';
      var isEmpty = state.text.trim() === '';

      textElement.textContent = isEmpty ? placeholder : state.text;
      textElement.classList.toggle('is-placeholder', isEmpty);

      if (textLayer) textLayer.hidden = isEmpty && state.symbol >= 0;

      var lines = state.text.split('\n');
      var longest = lines.reduce(function (max, line) { return Math.max(max, line.length); }, 0);

      if (counter) {
        var label = longest + '/' + config.maxChars;
        if (lines.length > 1) {
          label = lines.length + ' ' + (config.strings.lines || 'Zeilen') + ' · ' + label;
        }
        counter.textContent = label;
      }

      var firstLine = lines.filter(function (line) { return line.trim() !== ''; })[0] || '';
      var sample = isEmpty ? 'Aa' : firstLine;

      var sampleSize = Math.max(0.72, 1.25 - Math.max(0, sample.length - 5) * 0.09);
      root.style.setProperty('--pz-sample-fs', sampleSize + 'rem');

      Array.prototype.forEach.call(fontsHost.querySelectorAll('.pz__font-sample'), function (element) {
        element.textContent = sample;
      });

      layout();

      var symbolRef = layerByKey('symbol');
      if (symbolRef && !symbolRef.moved) placeSymbol();

      updateReset();
      syncProperties();
    }

    /* ---------------------------------------------------------- Schriften */

    config.fonts.forEach(function (font, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pz__font' + (index === state.font ? ' is-selected' : '');
      button.setAttribute('aria-pressed', index === state.font ? 'true' : 'false');
      button.dataset.pzFont = String(index);

      var sample = document.createElement('span');
      sample.className = 'pz__font-sample';
      sample.style.fontFamily = font.stack;
      sample.textContent = 'Aa';

      var label = document.createElement('span');
      label.className = 'pz__font-label';
      label.textContent = font.label;

      button.appendChild(sample);
      button.appendChild(label);
      fontsHost.appendChild(button);
    });

    fontsHost.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pz-font]');
      if (!button) return;

      state.font = parseInt(button.dataset.pzFont, 10) || 0;

      Array.prototype.forEach.call(fontsHost.querySelectorAll('.pz__font'), function (element) {
        var isActive = element === button;
        element.classList.toggle('is-selected', isActive);
        element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      syncProperties();
      layout();
    });

    /* -------------------------------------------------------- Druckfarbe */

    if (inkHost && inkColors.length) {
      inkColors.forEach(function (color, index) {
        inkHost.appendChild(inkSwatch(color.name, index, color.hex));
      });

      inkHost.addEventListener('click', function (event) {
        var button = event.target.closest('[data-pz-ink]');
        if (!button) return;
        event.preventDefault();

        // Ab jetzt bestimmt der Kunde die Druckfarbe, nicht der Automatismus.
        state.inkChosen = true;
        selectInk(parseInt(button.dataset.pzInk, 10) || 0);

        paint();
        syncProperties();
      });

      if (inkName && inkColors[0]) inkName.textContent = inkColors[0].name;
    }

    /* ------------------------------------------------------------- Zeichen */

    function renderSymbol(place) {
      var chosen = symbols[state.symbol];

      if (symbolElement) symbolElement.textContent = chosen ? chosen.char : '';
      if (symbolLayer) symbolLayer.hidden = !chosen;
      if (symbolName) symbolName.textContent = chosen ? chosen.name : '';

      if (textLayer) textLayer.hidden = state.text.trim() === '' && Boolean(chosen);

      layout();

      if (place && chosen) {
        placeSymbol();
      } else if (!chosen) {
        var textRef = layerByKey('text');
        if (textRef && !textRef.moved) {
          textRef.pos.y = textRef.anchor.y;
          clampPosition(textRef);
          applyLayer(textRef);
        }
      }

      updateReset();
      syncProperties();
    }

    if (symbolHost && symbols.length) {
      var noneButton = document.createElement('button');
      noneButton.type = 'button';
      noneButton.className = 'pz__symbol-option pz__symbol-option--none is-selected';
      noneButton.setAttribute('aria-pressed', 'true');
      noneButton.dataset.pzSymbol = '-1';
      noneButton.textContent = config.strings.symbolNone || 'Ohne';
      symbolHost.appendChild(noneButton);

      symbols.forEach(function (symbol, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'pz__symbol-option';
        button.setAttribute('aria-pressed', 'false');
        button.title = symbol.name;
        button.dataset.pzSymbol = String(index);

        var glyph = document.createElement('span');
        glyph.setAttribute('aria-hidden', 'true');
        glyph.textContent = symbol.char;
        button.appendChild(glyph);

        var name = document.createElement('span');
        name.className = 'visually-hidden';
        name.textContent = symbol.name;
        button.appendChild(name);

        symbolHost.appendChild(button);
      });

      symbolHost.addEventListener('click', function (event) {
        var button = event.target.closest('[data-pz-symbol]');
        if (!button) return;
        event.preventDefault();

        var next = parseInt(button.dataset.pzSymbol, 10);
        if (isNaN(next)) next = -1;

        var wasEmpty = state.symbol < 0;
        state.symbol = state.symbol === next ? -1 : next;

        var symbolRef = layerByKey('symbol');
        if (state.symbol < 0 && symbolRef) symbolRef.moved = false;

        Array.prototype.forEach.call(symbolHost.querySelectorAll('[data-pz-symbol]'), function (element) {
          var isActive = parseInt(element.dataset.pzSymbol, 10) === state.symbol;
          element.classList.toggle('is-selected', isActive);
          element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        renderSymbol(wasEmpty || (symbolRef && !symbolRef.moved));
      });
    }

    /* ----------------------------------------------------------- Aufdruck */

    // Erlaubt sind Buchstaben, Ziffern, Leerzeichen und Bindestrich — damit
    // Namen wie „Anna-Lena" oder „Anna Maria" gehen, Sonderzeichen wie % nicht.
    var ERLAUBT = /[^A-Za-z0-9À-ÖØ-öø-ÿ \-]/g;

    function readInput() {
      var value = input.value
        .replace(/\r\n?/g, '\n')
        .replace(/\t/g, ' ')
        .replace(ERLAUBT, '')
        .split('\n')
        .slice(0, config.maxLines)
        .map(function (line) { return line.slice(0, config.maxChars); })
        .join('\n');

      if (input.value !== value) input.value = value;
      state.text = value;
      renderText();
    }

    input.addEventListener('input', readInput);
    input.addEventListener('change', readInput);

    /* -------------------------------------------------------- Lederfarbe */

    function onOptionChange(event) {
      if (!document.contains(root)) {
        document.removeEventListener('change', onOptionChange);
        if (resizeObserver) resizeObserver.disconnect();
        return;
      }

      var select = event.target.closest('select[data-option-select]');
      if (!select) return;

      var picker = select.closest('[data-variant-picker]');
      if (!picker || picker.getAttribute('data-section-id') !== sectionId) return;
      if (select.getAttribute('data-option-select') !== String(config.colorIndex)) return;

      var base = colors[normalize(select.value)];
      if (!base) return;

      state.base = base;
      if (!state.inkChosen) selectInk(readableInk());
      applyPhoto(select.value);
      paint();
      layout();
      placeSymbol();
      syncProperties();
    }

    document.addEventListener('change', onOptionChange);

    /* --------------------------------------------------------------- Start */

    if (textLayer) textLayer.setAttribute('title', config.strings.moveText || '');
    if (symbolLayer) symbolLayer.setAttribute('title', config.strings.moveSymbol || '');

    layers.forEach(makeInteractive);

    if (resetButton) resetButton.addEventListener('click', resetLayout);

    var disclosure = root.querySelector('[data-pz-disclosure]');
    if (disclosure) {
      disclosure.addEventListener('toggle', function () {
        if (disclosure.open) layout();
      });
    }

    // Erst die zum Leder passende Druckfarbe bestimmen, dann zeichnen —
    // sonst blitzt beim Laden kurz eine unlesbare Farbe auf.
    selectInk(readableInk());

    applyPhoto(config.color);
    applyAll();
    paint();
    renderSymbol(false);
    renderText();
    root.hidden = false;

    if (window.ResizeObserver && stage) {
      resizeObserver = new ResizeObserver(function () { layout(); });
      resizeObserver.observe(stage);
    } else {
      window.addEventListener('resize', layout);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(layout).catch(function () {});
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pz]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
